import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Dropdown } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../../../services/authentication/AuthenticationService';
import { setCurrent } from '../../../../slices/user';
import { RootState } from '../../../../store';
import { useHistory } from 'react-router';
import Avatar from '../../avatar/Avatar';
import useRefreshUnreadNotificationCounts from '../../../../hooks/api/notification/useRefreshUnreadNotificationCounts';

const UserMenu: FC = () => {
  const user = useSelector((state: RootState) => state.user.current);
  const dispatch = useDispatch();
  const history = useHistory();
  const unreadNotificationCount = useSelector((state: RootState) => state.user.unreadNotificationCount);

  useRefreshUnreadNotificationCounts();

  return (
    <>
      <div className="user-menu">
        <Dropdown>
          {user && (
            <Dropdown.Toggle id="dropdown-basic" variant="link">
              <Avatar src={user.avatar} width={36} height={36}></Avatar>
              <span className="d-none d-lg-block">{`${user.firstName} ${user.name}`}</span>
              {unreadNotificationCount > 0 && (
                <span className="badge badge-danger rounded-pill ms-2">{unreadNotificationCount}</span>
              )}
            </Dropdown.Toggle>
          )}
          <Dropdown.Menu>
            <Dropdown.Item
              onClick={() => {
                history.push('/notifications');
              }}
            >
              <span className="mdi mdi-bell"></span>
              <FormattedMessage id={'userMenu.notifications'}></FormattedMessage>
              {unreadNotificationCount > 0 && (
                <span className="badge badge-danger rounded-pill ms-2">{unreadNotificationCount}</span>
              )}
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                logout();
                dispatch(setCurrent(null));
              }}
              className="separator"
            >
              <span className="mdi mdi-power"></span>
              <FormattedMessage id={'userMenu.logout'}></FormattedMessage>
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
};

export default UserMenu;
